import { MutationOptions } from '@tanstack/react-query';

import { useApiMutation } from '~/hooks';
import {
  createExtractionJobApi,
  cancelExtractionJobApi,
  validateExtractionJobApi,
  CreateExtractionJobData,
  CreateExtractionJobResponse,
} from '../repository';

/**
 * Mutation hook for creating extraction jobs
 */
export const useCreateExtractionJobMutation = (
  options?: MutationOptions<
    CreateExtractionJobResponse,
    CustomAxiosError,
    CreateExtractionJobData
  >,
) => {
  return useApiMutation({
    ...options,
    mutationFn: createExtractionJobApi,
  });
};

/**
 * Mutation hook for cancelling extraction jobs
 */
export const useCancelExtractionJobMutation = (
  options?: MutationOptions<
    { success: boolean; message: string },
    CustomAxiosError,
    string
  >,
) => {
  return useApiMutation({
    ...options,
    mutationFn: (jobId: string) => cancelExtractionJobApi(jobId),
  });
};

/**
 * Mutation hook for validating extraction task contacts
 */
export const useValidateExtractionJobMutation = (
  options?: MutationOptions<
    { success: boolean; message: string; data: unknown },
    CustomAxiosError,
    { taskId: string; retry_validation?: boolean; max_token?: number }
  >,
) => {
  return useApiMutation({
    ...options,
    mutationFn: ({ taskId, retry_validation, max_token }) =>
      validateExtractionJobApi(taskId, { retry_validation, max_token }),
  });
};
